import { Box } from '@mui/material';
import { LwButton } from 'redesign';
import { IconApproved, IconCancel } from 'assets/img';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { useIssueDocumentFormActions } from './hooks/use-issue-document-form-actions/use-issue-document-form-actions';
import { IssueDocumentFormData } from '../issue-document-form-content/issue-document-form-content.types';

export const IssueDocumentFormToolbox = () => {
  const { t } = useTranslation(['web-common', 'hq-screen-specific']);
  const formMethods = useFormContext<IssueDocumentFormData>();
  const { handleIssueDocument, handleCancel } = useIssueDocumentFormActions();

  const handleFormSubmit = () => {
    formMethods.handleSubmit(handleIssueDocument)();
  };

  return (
    <>
      <Box>
        <LwButton
          type="submit"
          iconColorMode="stroke"
          color="primary"
          startIcon={<IconApproved />}
          onClick={handleFormSubmit}
          disabled={formMethods.formState.isSubmitting}
        >
          {t('buttons.submit', { ns: 'web-common' })}
        </LwButton>
      </Box>
      <Box>
        <LwButton
          onClick={handleCancel}
          iconColorMode="fill"
          color="secondary"
          startIcon={<IconCancel />}
        >
          {t('buttons.cancel', { ns: 'web-common' })}
        </LwButton>
      </Box>
    </>
  );
};
